import {Auftragsverwaltung} from "../../../stores/auftragsverwaltung-mobx";
import {observer} from "mobx-react";
import {Component} from "react";
import {Button} from "semantic-ui-react";
import * as React from "react";
import {Icon} from "../../../core/components/icon/icon";


export interface EditToggleButtonProps {
    auftragsverwaltung: Auftragsverwaltung;
}

@observer
export class EditToggleButton extends Component<EditToggleButtonProps, any> {

    constructor(props: EditToggleButtonProps) {
        super(props);
        this.state = {};

        this.handleToggleEditingPerimeter = this.handleToggleEditingPerimeter.bind(this);
    }

    render(): React.ReactElement | null {
        const {auftragsverwaltung} = this.props;

	    if (!auftragsverwaltung.selectedProject?.isAlterable) {
		    return null;
	    }

        let editButtonIcon: React.ReactElement | null;
        let editButtonText: string | null;
        if (auftragsverwaltung.isEditingPerimeter) {
            editButtonIcon = <Icon name={"navigate_cross"} />;
            editButtonText = "Editieren beenden";
            if (auftragsverwaltung.ProjectPerimeterStore?.proposal) {
                editButtonText +=  " (ohne speichern)";
            }
        }
        else {
            editButtonIcon = <Icon name={"pencil"} selected/>;
            editButtonText = "Perimeter editieren";
        }

        return (
            <Button className={"editing"} secondary
                onClick={(e: React.MouseEvent) => {
				        this.handleToggleEditingPerimeter(e);
			        }}>
                {editButtonIcon}&nbsp;{editButtonText}
            </Button>
        );

    }

    private handleToggleEditingPerimeter(e: React.MouseEvent): void {
        e.preventDefault();
        const target = e.target as HTMLElement;
        target.blur();

        const {auftragsverwaltung} = this.props;
        auftragsverwaltung.setShowMap(true);

        const {isEditing} = auftragsverwaltung;
        if (!isEditing) {
            auftragsverwaltung.setEditing(true, "perimeter");
            return;
        }

        // editing ongoing
        // any pending edits?
        if (!auftragsverwaltung.ProjectPerimeterStore?.proposal) {
            auftragsverwaltung.setEditing(false);
            return;
        }

        // ignore edits?
        if (confirm("Nicht gespeicherte Änderungen. Änderungen verwerfen?")) {
            auftragsverwaltung.setEditing(false);
            return;
        }
        // do nothing
    }
}
